/**
 * ApprovalItem (P29 lift).
 *
 * Lifted verbatim from `sample-wireframe/client/src/pages/Home.tsx` lines
 * 771–773. The conic risk gauge is driven by the `--risk` CSS variable
 * the wireframe authored — `risk-gauge::after` masks the inner circle so
 * only the colored arc shows.
 */
import type { CSSProperties, JSX } from 'react';

interface ApprovalItemProps {
  title: string;
  requester: string;
  risk: number;
  type: string;
  sla: string;
  state: string;
  onClick?: () => void;
}

export function ApprovalItem({
  title,
  requester,
  risk,
  type,
  sla,
  state,
  onClick,
}: ApprovalItemProps): JSX.Element {
  const style = { ['--risk' as string]: `${risk}%` } as CSSProperties;
  return (
    <button type="button" className="approval-item" onClick={onClick}>
      <div className="approval-main">
        <strong>{title}</strong>
        <span>
          {requester} · {type}
        </span>
      </div>
      <div className="risk-gauge" style={style}>
        <span>{risk}</span>
      </div>
      <small>
        {state} · SLA {sla}
      </small>
    </button>
  );
}
